/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performResolutionObj: {},
  startQtr: '',
  planType: [],
  rebateProgram: [],
  errorMsgCMS: [],
  rebateProgramName: {},
  adjustmentData: [],
  rebateGroup: [],
  rebateGroupName: {},
  listRebateGroup: [],
  rebateCategoryValue: '',
  rebateGroupCategoryValue: '',
  selectedOptionValue: 'Single',
  agencyInfo: [],
  quarterlyReporting: [],
  displayObj: {
    startQtr: '',
    rebateProgramName: {},
    groupOfRebateProgramList: [],
    rebateGroupCategoryValue: '',
    quarterlyReporting: [],
    selectedOptionValue: 'Single',
    agencyInfo: [],
    rebateGroupFreezeQtr: 0,
  },
  getFlag: false,
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_CMS:
      return { ...state, performResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_CMS:
      return { ...state, resolutionDetailObj: action.detailScrData };
    case actionTypes.SET_MAX_QTR_ONLOAD:
      return { ...state, mxQtr: action.payload };
      case actionTypes.SET_CMS_RPT_ADJ_SINGLE_RPC_QTR:
  return { ...state, mxQtr:action.payload};
  case actionTypes.SET_CMS_RPT_GRP_RPC_QTR:
  return { ...state, mxQtr:action.payload};
    case actionTypes.GET_ERROR_MSG_CMS:
      return { ...state, errorMsgCMS: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_CMS:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_CMS:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_FROM_CMS:
      return { ...state, ...action.payload };
    case actionTypes.SELECT_OPTION:
      return { ...state, ...action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_CMS:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.GET_CMS_REBATE_GROUP:
      return { ...state, rebateGroup: action.payload };
    case actionTypes.GET_CMS_REBATE_GROUP_FREEZE_QTR:
      return { ...state, rebateGroupFreezeQtr: action.payload };
    case actionTypes.GET_CMS_REBATE_GROUP_NAME:
      return { ...state, ...action.payload };
    case actionTypes.GET_CMS_LIST_REBATE_GROUP:
      return { ...state, listRebateGroup: action.payload };
    case actionTypes.DISPATCH_FLAG:
      return { ...state, getFlag: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_CMS:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_CMS_LIST_REBATE_GROUP_NAME:
      return { ...state, ...action.payload };
    case actionTypes.SET_CMS_QUARTERLY_REPORTING:
      let displayObj = {
        ...state.displayObj,
        quarterlyReporting: action.payload,
      };
      return { ...state, quarterlyReporting: action.payload, displayObj };

    case actionTypes.SET_REFRESH_DATA_CMS:
      return {
        ...state,
        performResolutionObj: {},
        startQtr: '',
        planType: [],
        rebateProgram: [],
        errorMsgCMS: [],
        rebateProgramName: {},
        adjustmentData: [],
        rebateGroup: [],
        rebateGroupName: {},
        listRebateGroup: [],
        rebateCategoryValue: '',
        rebateGroupCategoryValue: '',
        selectedOptionValue: 'Single',
        agencyInfo: [],
        quarterlyReporting: [],
      };
    case actionTypes.SET_REFRESH_DATA_CMS_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    case actionTypes.SET_AGENCY_INFO:
      let displayObj1 = {
        ...state.displayObj,
        agencyInfo: action.payload,
      };
      return { ...state, agencyInfo: action.payload, displayObj: displayObj1 };
    // return { ...state, agencyInfo: action.payload };
    case actionTypes.RESET_CMS_QUARTERLY_REPORTING:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
export default reducer;
